module.exports = __webpack_public_path__ + "static/media/Mesa-de-trabajo-30.153fcde1.jpg";